<div class='category-list'>
    <div class="grid">
        <ef-category *ngFor='let category of categories' [category]='category'></ef-category>
    </div>
</div>
